module.exports = __webpack_public_path__ + "img/alert02.d62ede87.png";